import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IMedicine;

const medicineSlice = createSlice({
    name: "medicine",
    initialState,
    reducers: {
        setMedicine: (state, action: PayloadAction<IMedicine | undefined>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setMedicine } = medicineSlice.actions;
export default medicineSlice.reducer;

export const getMedicine = (state: RootState) => state.medicine;
